module.exports = __webpack_public_path__ + "static/media/hubspot.dabe7a63.webp";